import { render, staticRenderFns } from "./Technical.vue?vue&type=template&id=3e48ca6a&scoped=true&"
import script from "./Technical.vue?vue&type=script&lang=js&"
export * from "./Technical.vue?vue&type=script&lang=js&"
import style0 from "./Technical.vue?vue&type=style&index=0&id=3e48ca6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e48ca6a",
  null
  
)

export default component.exports